import { z } from 'zod';
export const firstValueRetrievalModeSchema = z.enum([
    'metadata_only',
    'semantic',
    'hybrid',
    'unknown',
]);
export const firstValueQualityTierSchema = z.enum(['high', 'medium', 'low', 'unknown']);
export const firstValueSignalTypeSchema = z.enum([
    'sdd_first_spec_generated',
    'sdd_first_spec_accepted',
    'mcp_first_successful_context_retrieval',
    'sdd_first_ticket_recommendation_converted',
]);
export const orgFirstValueDistinctIdSchema = z
    .string()
    .regex(/^cm_org_first_value:[0-9a-fA-F-]{36}$/u, 'distinct_id must be cm_org_first_value:<uuid>');
export const sddFirstSpecGeneratedPayloadSchema = z
    .object({
    time_since_setup_ms: z.number().int().nonnegative(),
    retrieval_mode: firstValueRetrievalModeSchema,
    ticket_was_recommended: z.boolean(),
    quality_tier: firstValueQualityTierSchema,
})
    .strict();
export const sddFirstSpecAcceptedPayloadSchema = z
    .object({
    time_since_setup_ms: z.number().int().nonnegative(),
})
    .strict();
export const mcpFirstSuccessfulContextRetrievalPayloadSchema = z
    .object({
    tool_name: z.literal('artifact_read'),
    session_bound: z.literal(true),
})
    .strict();
export const sddFirstTicketRecommendationConvertedPayloadSchema = z.object({}).strict();
//# sourceMappingURL=first-value-analytics.schemas.js.map